import classnames from 'classnames/bind'
import Button from 'components/button'
import Pagination from 'entities/pagination'
import RecruiterCandidateDestination from 'entities/user_notice/recruiter_destination_candidate'
import SpecialCandidateDestination from 'entities/user_notice/special_destination_candidate'
import TagCandidateDestination from 'entities/user_notice/tag_destination_candidate'
import PropTypes from 'prop-types'
import React, { Fragment, useState } from 'react'
import SelectionModal from './selection_modal'
import styles from './selector.module.scss'

const cx = classnames.bind(styles)
const Selector = ({
  className,
  recruiters,
  recruiterIds,
  recruitersPagination,
  specials,
  specialTypes,
  tags,
  tagIds,
  tagsPagination,
  isLoadingRecruiters,
  isLoadingTags,
  isLoadingSpecials,
  onChange,
  onChangeRecruitersPage,
  onChangeRecruitersKeyword,
  onChangeTagsPage,
  onChangeTagsKeyword
}) => {
  const [isOpened, setOpenState] = useState(false)

  const handleUpdateSelection = (newRecruiterIds, newTagIds, newSpecialTypes) => {
    onChange(newRecruiterIds, newTagIds, newSpecialTypes)
    setOpenState(false)
  }

  return (
    <Fragment>
      <Button className={cx(className, styles.button)} intent="none" raised onClick={() => setOpenState(true)}>
        {I18n.t('components.destinations_field.selector.button.setting')}
      </Button>
      <SelectionModal
        isOpened={isOpened}
        recruiters={recruiters}
        recruiterIds={recruiterIds}
        recruitersPagination={recruitersPagination}
        tags={tags}
        tagIds={tagIds}
        tagsPagination={tagsPagination}
        specials={specials}
        specialTypes={specialTypes}
        isLoadingRecruiters={isLoadingRecruiters}
        isLoadingTags={isLoadingTags}
        isLoadingSpecials={isLoadingSpecials}
        onCancelSelection={() => setOpenState(false)}
        onChangeRecruitersPage={onChangeRecruitersPage}
        onChangeRecruitersKeyword={onChangeRecruitersKeyword}
        onChangeTagsPage={onChangeTagsPage}
        onChangeTagsKeyword={onChangeTagsKeyword}
        onFinishSelection={(newRecruiterIds, newTagIds, newSpecialTypes) =>
          handleUpdateSelection(newRecruiterIds, newTagIds, newSpecialTypes)
        }
      />
    </Fragment>
  )
}

Selector.propTypes = {
  className: PropTypes.string,
  recruiters: PropTypes.arrayOf(PropTypes.instanceOf(RecruiterCandidateDestination)).isRequired,
  recruiterIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  recruitersPagination: PropTypes.instanceOf(Pagination).isRequired,
  specials: PropTypes.arrayOf(PropTypes.instanceOf(SpecialCandidateDestination)).isRequired,
  specialTypes: PropTypes.arrayOf(PropTypes.string).isRequired,
  tags: PropTypes.arrayOf(PropTypes.instanceOf(TagCandidateDestination)).isRequired,
  tagIds: PropTypes.arrayOf(PropTypes.number).isRequired,
  tagsPagination: PropTypes.instanceOf(Pagination).isRequired,
  isLoadingRecruiters: PropTypes.bool.isRequired,
  isLoadingTags: PropTypes.bool.isRequired,
  isLoadingSpecials: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onChangeRecruitersPage: PropTypes.func.isRequired,
  onChangeRecruitersKeyword: PropTypes.func.isRequired,
  onChangeTagsPage: PropTypes.func.isRequired,
  onChangeTagsKeyword: PropTypes.func.isRequired
}

Selector.defaultProps = {
  className: null
}

export default Selector
